export default __webpack_public_path__ + "maps-examples-user-location-annotation-1200-75aa34e5d33bc351d2de7d2b5bcbc9a7.webp";